/*=========================================================================================
  File Name: getters.js
  Description: POS Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS State Module
  Author: Tan Tran
==========================================================================================*/

export default {
    categoriesFromProductsList: state => {
        let results = [];
        let map = new Map();

        for(let item of state.products) {
            if(!map.has(item.categoryId)) {
                map.set(item.categoryId, true);
                results.push({
                    categoryId : item.categoryId,
                    categoryName : item.category
                });
            }
        }
        //console.log(results)
        return results;
        
    },
    productsByCategoryId: state => id => {
        //console.log(id);
        if (id == null) {
            return [];
        }
        let products = state.products.filter(obj => {
            return obj.categoryId === id;
        })

        return products;
    },

    
}